import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import Navbar from '../components/navbar.svelte'
import Popup from '../components/popup.svelte'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const { $, boostPopupOptions } = window

const $body = $(document.body)

export default {
	init() {

		let navbarContainer = document.getElementById('navbar_container')
		navbarContainer &&
			new Navbar({
				target: navbarContainer,
			})
			
		// JavaScript to be fired on all pages
		const mobileMenu = new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})
		$('#toggle_nav').on('click', mobileMenu.show)

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		let $blocksGallery = $('.wp-block-gallery .wp-block-image > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		let $wpBlockImg = $('.wp-block-image:not(.no-bp) > img')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		let $wpMediaTxtBlockImg = $(
			'.wp-block-media-text:not(.no-bp) .wp-block-media-text__media'
		)
		if ($wpMediaTxtBlockImg.length) {
			$wpMediaTxtBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		if (boostPopupOptions) {
			new Popup({
				target: document.body,
				props: {
					options: boostPopupOptions,
				},
			})
		}

		scrollReveals()
	},
}

function scrollReveals() {
	let $hero = $('#heroContent')
	if ($hero.length) {
		let hero_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#heroContent',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})

		hero_tl.fromTo(
			'#heroContent',
			{
				opacity: 0,
				x: -80,
			},
			{
				delay: 0.25,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		if (!window.matchMedia('(max-width: 640px)').matches) {
			hero_tl.fromTo(
				'#heroContent .hero-green-line',
				{
					width: 0,
				},
				{
					delay: 0,
					duration: 2,
					width: '100%',
				}
			)
		} else {
			hero_tl.fromTo(
				'#heroContent .hero-green-line',
				{
					width: 0,
				},
				{
					delay: 0,
					duration: 1,
					width: '100%',
				}
			)
		}
	}

	let $cta = $('#cta')
	if ($cta.length) {
		let cta_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#cta',
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})

		cta_tl.fromTo(
			'#cta .cta-content h2',
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0.1,
				duration: 0.25,
				opacity: 1,
				x: 0,
			}
		)
		cta_tl.fromTo(
			'#cta .cta-content p',
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0,
				duration: 0.25,
				opacity: 1,
				x: 0,
			}
		)
		cta_tl.fromTo(
			'#cta .cta-content .btn',
			{
				opacity: 0,
				y: 40,
			},
			{
				delay: 0,
				duration: 0.25,
				opacity: 1,
				y: 0,
			}
		)
	}
}
